
import { ChoicesMixin } from '~/mixins/choices'

export default {
    mixins: [ChoicesMixin]
}
